<template>
  <div>
    <div class="d-flex mb-2">
      <div class="side-frame"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Proofing No：{{ formData.proofingNo ? formData.proofingNo : 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          class="mr-2"
          style="font-size: 12px"
          :variant="
            formData.proofingStatus === 'Y'
              ? 'primary'
              : formData.proofingStatus === 'S'
              ? 'success'
              : ''
          "
        >
          {{ formData.v_proofingStatus }}
        </b-badge>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('INDEX.form_label_business_name') || '业务人员'"
          >
            <dict-select
              url="/sys/common/dict/userDict"
              :selectedLabel.sync="formData.salesPersonName"
              v-model="formData.salesPersonCode"
              :placeholder="
                $l('INDEX.form_label_please_select_a_business_person') ||
                  '请选择业务人员'
              "
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_request_date') || '开发依赖日期'"
          >
            <el-date-picker
              v-model="formData.requestDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('form_placeholder_request_date') || '请选择开发依赖日期'
              "
              style="width: 100%"
              clearable
              :picker-options="expireTimeOption"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item :label="$l('form_label_finish_date') || '要求完成日期'">
            <el-date-picker
              v-model="formData.finishDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('form_placeholder_finish_date') || '请选择要求完成日期'
              "
              style="width: 100%"
              clearable
              :picker-options="expireTimeOption"
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item :label="$l('INDEX.form_label_designer') || '设计人员'">
            <dict-select
              url="/sys/common/dict/userDict"
              :selectedLabel.sync="formData.designerName"
              v-model="formData.designerCode"
              :placeholder="
                $l('INDEX.form_label_please_select_designer') ||
                  '请选择设计人员'
              "
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item :label="$l('form_label_sales_season') || '销售季节'">
            <dict-select
              url="/master/common/dict/biz"
              :body="sampleSalesSeasonParams"
              v-model="formData.sampleSalesSeason"
              :placeholder="
                $l('pe_select_sampleSalesSeason') || '请选择销售季节'
              "
              size="small"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_customer_sample_number') || '客户样品款号'"
            prop="cusSampleNo"
          >
            <el-input
              v-model="formData.cusSampleNo"
              :placeholder="
                $l('form_placeholder_customer_sample_no') ||
                  '请输入客户样品款号'
              "
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_customer') || '客户'"
            prop="cusCode"
          >
            <dict-select
              url="/master/common/dict/customerSelect"
              v-model="formData.cusCode"
              clearable
              filterable
              :placeholder="
                $l('INDEX.form_label_please_select_a_customer') || '请选择客户'
              "
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_customer_contact') || '客户联系人'"
          >
            <el-input
              v-model="formData.cusContacts"
              :placeholder="
                $l('form_placeholder_customer_contact') || '请输入客户联系人'
              "
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item
            :label="
              $l('form_label_customer_contact_number') || '客户联系人电话'
            "
          >
            <el-input
              v-model="formData.cusContactsPhone"
              :placeholder="
                $l('form_placeholder_customer_contact_number') ||
                  '请输入客户联系人电话'
              "
              clearable
              maxlength="11"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_proofing_factory') || '打样工厂'"
          >
            <dict-select
              url="/master/common/dict/scmCooperated"
              :body="scmParams"
              v-model="formData.scmCode"
              :placeholder="
                $l('form_placeholder_proofing_factory') || '请选择打样工厂'
              "
              size="small"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_factory_contact') || '工厂联系人'"
          >
            <el-input
              v-model="formData.scmContacts"
              :placeholder="
                $l('form_placeholder_factory_contact') || '请输入工厂联系人'
              "
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_factory_contact_number') || '工厂联系人电话'"
          >
            <el-input
              v-model="formData.scmContactsPhone"
              :placeholder="
                $l('form_placeholder_factory_contact_number') ||
                  '请输入工厂联系人电话'
              "
              clearable
              maxlength="11"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 4 }">
          <el-form-item :label="$l('form_label_price') || '单价'">
            <el-input-number
              v-model="formData.unitPrice"
              :placeholder="$l('form_placeholder_price') || '请输入单价'"
              controls-position="right"
              :step="0.01"
              :precision="2"
              :min="0"
              clearable
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 4 }">
          <el-form-item
            :label="$l('form_label_proofing_quantity') || '打样数量'"
          >
            <el-input-number
              v-model="formData.proofingQty"
              :placeholder="
                $l('form_placeholder_proofing_qty') || '请输入打样数量'
              "
              controls-position="right"
              :step="1"
              :min="0"
              clearable
              step-strictly
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 4 }">
          <el-form-item :label="$l('form_label_sample_cost') || '样品费用'">
            <el-input-number
              v-model="proofingAmount"
              :placeholder="
                $l('form_placeholder_proofing_amount') || '请输入样品费用'
              "
              controls-position="right"
              :step="0.01"
              :precision="2"
              :min="0"
              clearable
              style="width:100%"
              disabled
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 4 }">
          <el-form-item :label="$l('form_label_additional_cost') || '附加费用'">
            <el-input-number
              v-model="formData.proofingFee"
              :placeholder="
                $l('form_placeholder_additional_cost') || '请输入附加费用'
              "
              controls-position="right"
              :step="0.01"
              :precision="2"
              :min="0"
              clearable
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item :label="$l('form_label_total_amount') || '合计金额'">
            <el-input
              v-model="totalAmount"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '系统自动生成'
              "
              disabled
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_proofing_purpose') || '打样用途'"
          >
            <el-input
              v-model="formData.proofingUse"
              :placeholder="
                $l('form_placeholder_proofing_purpose') || '请输入打样用途'
              "
              type="textarea"
              clearable
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 8 }">
          <el-form-item :label="$l('form_label_process_desc') || '工艺说明'">
            <el-input
              v-model="formData.bookTechDescription"
              :placeholder="
                $l('form_placeholder_process_desc') || '请输入工艺说明'
              "
              type="textarea"
              clearable
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_development_desc') || '开发说明'"
          >
            <el-input
              v-model="formData.developDescription"
              :placeholder="
                $l('form_placeholder_development_desc') || '请输入开发说明'
              "
              type="textarea"
              clearable
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d2-mt d-flex justify-content-end" v-if="!disabled">
      <el-button size="mini" type="primary" @click="save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="back()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import Math from '@/libs/util.math.js'
import { mapActions } from 'vuex'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    isAddOperation: { type: Boolean, default: false },
    proofingCode: String,
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      rules: {
        cusCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_a_customer') ||
              '请选择客户',
            trigger: ' change',
          },
        ],
        cusSampleNo: [
          {
            required: true,
            message:
              this.$l('form_placeholder_customer_sample_no') ||
              '请输入客户样品款号',
            trigger: ' blur',
          },
        ],
      },
      scmParams: {},
      sampleSalesSeasonParams: { dictType: 'salesSeason' },
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() <= Date.now() - 8.64e7
        },
      },
    }
  },
  computed: {
    proofingAmount: {
      get() {
        if (!this.formData) return 0
        const { unitPrice, proofingQty } = this.formData
        if (!unitPrice || !proofingQty) return 0
        let m = 0,
          s1 = proofingQty.toString(),
          s2 = unitPrice.toString()
        try {
          m += s1.split('.')[1].length
        } catch (e) {
          m += 0
        }
        try {
          m += s2.split('.')[1].length
        } catch (e) {
          m += 0
        }
        return (
          (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
          Math.pow(10, m)
        )
      },
      set() {},
    },
    totalAmount() {
      if (!this.formData) return 0
      const { proofingFee } = this.formData

      let r1, r2, m
      try {
        r1 = this.proofingAmount.toString().split('.')[1].length
      } catch (e) {
        r1 = 0
      }
      try {
        r2 = proofingFee.toString().split('.')[1].length
      } catch (e) {
        r2 = 0
      }
      m = Math.pow(10, Math.max(r1, r2))
      return (this.proofingAmount * m + proofingFee * m) / m
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.proofingCode) return
      this.$api
        .proofingInfoDetailApi({ proofingCode: this.proofingCode })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      this.formData.proofingAmount = this.proofingAmount
      this.loadingOpen()
      this.$api
        .proofingInfoSaveApi({
          ...this.formData,
          totalAmount: this.totalAmount,
        })
        .then((res) => {
          this.loadingClose()
          const { status, body } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })

            if (this.isAddOperation) {
              // this.closeCurPage()
              this.$router.replace({
                name: 'sample-proofing-detail',
                params: {
                  proofingCode: body,
                  pageType: 'edit',
                },
              })
            }
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
</style>
